import { render, staticRenderFns } from "./Nldc.vue?vue&type=template&id=5d825454&scoped=true&"
import script from "./Nldc.vue?vue&type=script&lang=js&"
export * from "./Nldc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d825454",
  null
  
)

export default component.exports